const save = async function(beforeSave) {
  if (typeof beforeSave === 'function' ) {
    const resp = beforeSave();
   if (!resp) return;
  }
  this.dialog = false;
  this.setProgress({message: 'Guardando...', show:true});

  if(!await this.assignAccess()) {
    this.setProgress({show:false});
    this.getError('no se pudo obtener acceso')
    return;
  } // if

  const method = this.selectedItem.id ? this.edit : this.add;
  method(this.selectedItem)
    .then(r => {
      this.setProgress({show:false});
      //console.log({r})
      if (r.id) {
        if (!this.selectedItem.id) {
          /* this.selectedItem.id = r.id; */
          this.rows.push(this.selectedItem);
          Object.assign(this.selectedItem, r);
          if (this.addToAList) this.addToAList(this.selectedItem);
        } else {
          const row = this.rows.find(r => r.id === this.selectedItem.id);
          Object.assign(row ,this.selectedItem); // no reemplaza ni edita las propiedades de tipo array
          if (this.afterSave) this.afterSave(row, this.selectedItem, r);
        }
        this.setSnackbar({message:'Guardado.',class:'success'})
      } else {
        if (this.saveError) this.saveError(r);
        this.setSnackbar({message:'Ocurrió un problema.',class:'error'});
      }
    })
    .catch(e => {
      if (this.saveError) this.saveError(e);
      this.getError(e)
    })
}

const addItem = function() {
  this.selectedItem = {...this.defaultItem};
  this.dialog = true;
}

const askForDelete = function(item) {
  if (item.is_deleted != true) {
    this.deleteDialog = true;
    this.selectedItem = item;
  }
}

const deleteItem = async function (item) {
  this.deleteDialog = false;
  Object.keys(item).forEach(key => !['id', 'is_deleted'].includes(key) && delete item[key])
  item.is_deleted = true;
  delete item.file;
  this.setProgress({show:true,message: 'Eliminando...'});
  if(!await this.assignAccess()) {
    this.getError('assignAccess')
    return;
  }
  this.edit(item)
    .then(r => {
      this.setProgress({show: false});
      this.rows.splice(this.rows.indexOf(item), 1);
      //this.$store.dispatch('set', {key: this.storeKey, val: this.rows.filter(f => f.id != item.id)});
      if (this.removeFromList) this.removeFromList(item);
      this.setSnackbar({class:'success',message: 'Registro eliminado!'});
    })
    .catch(e => this.getError(e))
} // deleteItem

export {
  save,
  askForDelete,
  addItem,
  deleteItem,
}